import ProfilePictureUpload from "./ProfilePictureUpload";
export default ProfilePictureUpload;